const isCrossStoreImpossible = () => {
  let isImpossible = false;
  try {
    sessionStorage.setItem('isCrossStorePossible', 'yes');
  } catch (err) {
    isImpossible = true;
  }
  return isImpossible;
};

export default isCrossStoreImpossible;
